import { assoc, map } from 'ramda'

const uniqid = require('uniqid')

const addId = map((item) => assoc('id', uniqid(), item))

export default addId
